module.exports = __webpack_public_path__ + "media/images/game_icon/en/VG1002-9732f1596673ecfa6b2337eee9f8e2ff.png";